import * as s from "./website-content.scss";
import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {WebsiteBlackImageComponent} from "../black/image/WebsiteBlackImageComponent";
import {WebsiteBlackBlockComponent} from "../black/block/WebsiteBlackBlockComponent";
import {WebsiteBlackCasesFlowComponent} from "../black/cases/flow/WebsiteBlackCasesFlowComponent";
import {Resources} from "../../../../../resources/Resources";

export class WebsiteContentAuditStructureComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.structStartText"),
                            title: Resources.t("words.structTitle"),
                            description: Resources.t("words.structDescription"),
                            people: false,
                            center: true,
                            background: "structure"
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackImageComponent(NetworkVendor.image("blog-ae.webp"), Resources.t("words.structSeoAudit")))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackBlockComponent({
                            text: Resources.t("words.structBadPracticesWarning"),
                            icon: "structure"
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackCasesFlowComponent({
                            description: Resources.t("words.structToolDescription"),
                            cases: {
                                cases: [
                                    {
                                        name: Resources.t("words.structStructureAnalysis"),
                                        description: Resources.t("words.structStructureAnalysisDescription"),
                                        icon: "code",
                                        shadow: "none"
                                    }, {
                                        name: Resources.t("words.structSpeedAnalysis"),
                                        description: Resources.t("words.structSpeedAnalysisDescription"),
                                        icon: "rocket",
                                        shadow: "none"
                                    }, {
                                        name: Resources.t("words.structAccessibilityAnalysis"),
                                        description: Resources.t("words.structAccessibilityAnalysisDescription"),
                                        icon: "page",
                                        shadow: "none"
                                    }
                                ]
                            }
                        }))}
                    </div>
                </div>
            </div>
        `;
    }
}
